<div [ngbTooltip]="tipContent"><stepper [steps]="StatusList" [activeIndex]="ActiveIndex()"  ></stepper></div>

<ng-template #tipContent>
 @if(CurrentStatus.trackingDate) { {{CurrentStatus.trackingDate  | date:'dd.MM.yyyy hh:mm'}}: } {{CurrentStatus.trackingDescription}}
</ng-template>
